import { useSelector } from 'react-redux'
import { stepSearchQuerySelector } from '../selectors'

export function useStepSearchQuery() {
  return useSelector(stepSearchQuerySelector)
}
